/**
 * Subscription plan configuration — single source of truth for all pricing,
 * plan names, features, and trial settings shown across the app.
 *
 * To change a price or feature, update it here — BillingPage and LandingPage
 * both read from this file.
 */

export const TRIAL_DAYS = 7;

export const PLANS = {
  monthly: {
    label: "Monthly Plan",
    price: 5.99,
    interval: "month",
    features: [
      "Personalized weekly training plans",
      "FTP & heart rate zone targeting",
      "Wahoo ELEMNT direct sync",
      "Race calendar & event-based planning",
      "Recovery check-ins that adapt your load",
      "FIT file import from Garmin",
      "Cancel anytime",
    ],
  },
} as const;

/** Human-readable price string */
export const PLAN_DISPLAY = {
  monthly: `$${PLANS.monthly.price.toFixed(2)}`,
} as const;
